/* eslint-disable   no-unused-vars */
/* eslint-disable    eqeqeq */
/* eslint-disable  jsx-a11y/alt-text */

import React, { useCallback, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Header from "../components/header/header.component";
import TrustLogosRow from "../components/trust-logos-row/trust-logos-row.component";
import Footer from "../components/footer/footer.component";
import "./Template.scss";
import chevronIcon from "../assets/img/chevron-right-solid-01.png";
import "./_financial_calculator.scss";
import "./_ml-responsive.scss";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import BadCreditImg from "../assets/img/debt-consolidation-loan-bad-credit.png";
import ApplyNowButton from "../assets/img/applynow.jpeg";
import SavingsEstimateButton from "../assets/img/debt-consolidation-savings-estimate.jpeg"

import fetchWPContent from "../api/wp-api";
const DebtConsolidationLoanSavings = () => {
  const [content, setContent] = useState("");
  const [wptitle, setTitle] = useState("");
  const [isReady, setReady] = useState(false);
  const history = useHistory();
  const onCheckNow = (event) => {
    event.preventDefault();
    let debtAmount = event.target.debtAmount.value;
    if (debtAmount != " ") {
      history.push(`/apply-loan?debt_amount=${debtAmount}`, {
        debtAmount: debtAmount,
      });
    } else if (debtAmount == " ") {
      event.target.debtAmount.classList.add("invalid");
    }
  };
  const getContentRender = async (page) => {
    console.log("test page", page);

    const wpdata = await fetchWPContent(page);
    console.log("check", wpdata);
    if (wpdata) {
      setContent(wpdata.render);
      setTitle(wpdata.title.replace(/&#8211;/, "-"));
      setReady(true);
    }
  };
  useEffect(() => {
    getContentRender("debt-consolidation-loan-savings");
  }, []);

  return (

    <Container fluid className=" themeLayout full-width-content template financial-calculator">
      <Row className="no-gutter site-header header">
        <Col sm={12}>
          <Header />
        </Col>
      </Row>
 
      <div className="no-gutter site-inner">
        <div className="content-sidebar-wrap">
          <div className="content">
            <div className="  article entry ">
              <header className="entry-header">
                <h1 className="entry-title">{wptitle ? wptitle : null}</h1>
              </header>
    

<p>
    Looking to consolidate your credit cards and <u>save money each month</u>? 
    <a href="/apply-loan/">
        <img loading="lazy" src={BadCreditImg}
        alt="" width="600" height="220" class="alignright main-img"/>
    </a>
</p>
<p><a href="/apply-loan/">Get a free quote</a> to see how much you can save each month.</p>
<p><strong>Speak to a loan counselor now at</strong> <a href="tel:800-300-9550">800-300-9550</a></p>

<p>Here is a small sampling of debt consolidation loans we’ve made for our clients. Review these examples and then <a href="/apply-loan/">see if you qualify for a low rate debt consolidation loan</a>. Consolidate your debt into one low monthly payment you can afford.</p>
<p><strong>Debt Consolidation Loan Savings</strong></p>
<table class="tablepress consolidation-loan-table">
<thead>
<tr class="row-1 odd">
	<th>Consolidated Debt</th><th class="column-2">State</th><th class="column-3">Original APR*</th><th class="column-4">New APR</th><th class="column-5">Original Interest Cost</th><th class="column-6">New Interest Cost</th><th class="column-7">Interest Savings</th>
</tr>
</thead>
<tbody class="row-hover">
<tr class="row-2 even">
	<td class="column-1">$11,621.84 </td><td class="column-2">FL</td><td class="column-1">24.99%</td><td class="column-3">7.60%</td><td class="column-1">$3,263.14 </td><td class="column-3">$942.00</td><td class="column-3">$2,321.14 </td>
</tr>
<tr class="row-3 odd">
	<td class="column-1">$14,201.02 </td><td class="column-2">NY</td><td class="column-1">24.99%</td><td class="column-3">9.30%</td><td class="column-1">$4,333.48 </td><td class="column-3">$1,534.22 </td><td class="column-3">$2,799.26 </td>
</tr>
<tr class="row-4 even">
	<td class="column-1">$13,253.61 </td><td class="column-2">CA</td><td class="column-1">12.09%</td><td class="column-3">10.33%</td><td class="column-1">$1,732.46 </td><td class="column-3">$1,473.00 </td><td class="column-3">$259.46</td>
</tr>
<tr class="row-5 odd">
	<td class="column-1">$35,000.00 </td><td class="column-2">NC</td><td class="column-1">18.67%</td><td class="column-3">10.41%</td><td class="column-1">$14,264.00 </td><td class="column-3">$7,594.00 </td><td class="column-3">$6,670.00 </td>
</tr>
<tr class="row-6 even">
	<td class="column-1">$9,123.09 </td><td class="column-2">OK</td><td class="column-1">17.78%</td><td class="column-3">10.83%</td><td class="column-1">$2,555.00 </td><td class="column-3">$1,511.00 </td><td class="column-3">$1,044.00 </td>
</tr>
<tr class="row-7 odd">
	<td class="column-1">$12,361.86 </td><td class="column-2">AL</td><td class="column-1">24.99%</td><td class="column-3">13.11%</td><td class="column-1">$5,329.00 </td><td class="column-3">$2,655.00 </td><td class="column-3">$2,674.00 </td>
</tr>
<tr class="row-8 even">
	<td class="column-1">$25,624.74 </td><td class="column-2">NY</td><td class="column-1">21.43%</td><td class="column-3">13.57%</td><td class="column-1">$16,338.00 </td><td class="column-3">$9,808.00 </td><td class="column-3">$6,530.00 </td>
</tr>
<tr class="row-9 odd">
	<td class="column-1">$35,000.00 </td><td class="column-2">KY</td><td class="column-1">19.40%</td><td class="column-3">16.35%</td><td class="column-1">$19,937.00 </td><td class="column-3">$16,455.00 </td><td class="column-3">$3,482.00 </td>
</tr>
<tr class="row-10 even">
	<td class="column-1">$11,118.09 </td><td class="column-2">FL</td><td class="column-1">20.93%</td><td class="column-3">18.18%</td><td class="column-1">$6,904.00 </td><td class="column-3">$5,887.00 </td><td class="column-3">$1,017.00 </td>
</tr>
<tr class="row-11 odd">
	<td class="column-1">$15,474.74 </td><td class="column-2">TN</td><td class="column-1">24.99%</td><td class="column-3">18.87%</td><td class="column-1">$6,672.00 </td><td class="column-3">$4,908.00 </td><td class="column-3">$1,764.00 </td>
</tr>
</tbody>
</table>


<div class="ml-responsive-table ml-responsive-table-0"><dl class="ml-grid ml-clearfix ml-row-0"></dl><dl class="ml-grid ml-clearfix ml-row-1"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$11,621.84 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">FL</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">24.99%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">7.60%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$3,263.14 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$942.00</dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$2,321.14 </dd></dl><dl class="ml-grid ml-clearfix ml-row-2"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$14,201.02 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">NY</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">24.99%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">9.30%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$4,333.48 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$1,534.22 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$2,799.26 </dd></dl><dl class="ml-grid ml-clearfix ml-row-3"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$13,253.61 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">CA</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">12.09%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">10.33%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$1,732.46 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$1,473.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$259.46</dd></dl><dl class="ml-grid ml-clearfix ml-row-4"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$35,000.00 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">NC</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">18.67%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">10.41%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$14,264.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$7,594.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$6,670.00 </dd></dl><dl class="ml-grid ml-clearfix ml-row-5"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$9,123.09 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">OK</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">17.78%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">10.83%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$2,555.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$1,511.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$1,044.00 </dd></dl><dl class="ml-grid ml-clearfix ml-row-6"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$12,361.86 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">AL</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">24.99%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">13.11%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$5,329.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$2,655.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$2,674.00 </dd></dl><dl class="ml-grid ml-clearfix ml-row-7"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$25,624.74 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">NY</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">21.43%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">13.57%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$16,338.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$9,808.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$6,530.00 </dd></dl><dl class="ml-grid ml-clearfix ml-row-8"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$35,000.00 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">KY</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">19.40%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">16.35%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$19,937.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$16,455.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$3,482.00 </dd></dl><dl class="ml-grid ml-clearfix ml-row-9"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$11,118.09 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">FL</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">20.93%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">18.18%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$6,904.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$5,887.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$1,017.00 </dd></dl><dl class="ml-grid ml-clearfix ml-row-10"><dt class="ml-title ml-table">Consolidated Debt</dt><dd class="ml-value ml-table">$15,474.74 </dd><dt class="ml-title ml-table">State</dt><dd class="ml-value ml-table">TN</dd><dt class="ml-title ml-table">Original APR*</dt><dd class="ml-value ml-table">24.99%</dd><dt class="ml-title ml-table">New APR</dt><dd class="ml-value ml-table">18.87%</dd><dt class="ml-title ml-table">Original Interest Cost</dt><dd class="ml-value ml-table">$6,672.00 </dd><dt class="ml-title ml-table">New Interest Cost</dt><dd class="ml-value ml-table">$4,908.00 </dd><dt class="ml-title ml-table">Interest Savings</dt><dd class="ml-value ml-table">$1,764.00 </dd></dl></div>


<p>
<a href="/apply-loan/" class="image-link">
                    <img 
                        class="aligncenter size-full" 
                        src={SavingsEstimateButton}
                        alt="debt consolidation savings estimate" /></a>
                        </p>



                        <p>National Debt Relief works sincerely and tirelessly to make sure our clients successfully regain control over their financial lives. <strong>Your success is our #1 priority.</strong></p>

                        <a href="/apply-loan/">Click Here To Get A Free Savings Estimate</a><p></p>
                        <p>You can be like our clients who save thousands on their unsecured debts with one low monthly payment they can afford.</p>
                        <p>You can be part of this group who have successfully conquered their debt problems. National Debt Relief is here to help you make that possible.</p>
                        <p>The ultimate goal is to make sure you do not land in the same debt ridden situation again.</p>
                        <p><a href="/apply-loan">National Debt Relief</a> is a top rated debt consolidation company that is focused on helping our clients. Your success is our #1 priority.</p>
                        <p>
    <a href="/apply-loan/"><img src={ApplyNowButton} class="alignright"/></a>
    The time to work on your debt problems is here. This is the chance for you to pave a way and be like the other National Debt Relief clients who succeeded in consolidating their debts through our&nbsp;
    <a href="/apply-loan/">debt consolidation loan program</a>. 
    Get yourself included in our list of success stories. Give us a call so we can discuss your unique financial situation. You can also fill out the short form on this page and a debt consolidation professional will get in touch with you immediately.
</p>
</div>
          </div>
          <div className="after-content-form">
        <form id="do--you-qualify-form" onSubmit={onCheckNow}>
          <h3 class="widget-title ">Do you qualify for debt consolidation?</h3>
          <div className="apply_form_fields_wrapper">
            <div className="select-wrapper">
              <select
                name="debtAmount"
                className="get-started-form-input "
                id="id_debt_amount"
              >
                <option value=" " defaultValue="1">
                  Your Debt Amount
                </option>

                <option value="$0 - $4,999">$0 - $4,999</option>

                <option value="$5,000 - $7,499">$5,000 - $7,499</option>

                <option value="$7,500 - $9,999">$7,500 - $9,999</option>

                <option value="$10,000 - $14,999">$10,000 - $14,999</option>

                <option value="$15,000 - $19,999">$15,000 - $19,999</option>

                <option value="$20,000 - $29,999">$20,000 - $29,999</option>

                <option value="$30,000 - $39,999">$30,000 - $39,999</option>

                <option value="$40,000 - $49,999">$40,000 - $49,999</option>

                <option value="$50,000 - $59,999">$50,000 - $59,999</option>

                <option value="$60,000 - $69,99">$60,000 - $69,999</option>

                <option value="$70,000 - $79,999">$70,000 - $79,999</option>

                <option value="$80,000 - $89,999">$80,000 - $89,999</option>

                <option value="$90,000 - $99,999">$90,000 - $99,999</option>

                <option value="$100,000+">$100,000+</option>
              </select>
              <div className="do-you-qualify-button">
                <button type="submit" className="button">
                  Check Now
                  <span className="fa fa-chevron-right" aria-hidden="true">
                    <img src={chevronIcon} />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
        </div>
      </div>
  
      <Row className="no-gutter main-footer">
        <Col md={12}>
          <TrustLogosRow />
        </Col>
      </Row>

      <Footer />
    </Container>
  );
};
export default DebtConsolidationLoanSavings;
